import { render, staticRenderFns } from "./coreServe.vue?vue&type=template&id=763e4fd1&scoped=true"
import script from "./coreServe.vue?vue&type=script&lang=js"
export * from "./coreServe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e4fd1",
  null
  
)

export default component.exports